import * as React from 'react';
import { Container, DropzoneInfoContainerFull, DropzoneInfoContainerLabelMini, DropzoneInfoContainerMini, FittedLoader, StyledDropzoneArea, StyledDropzoneFileRowContainer, } from './FileDropzone.styles';
import Dropzone from 'react-dropzone';
import DropzoneFileRowContainer from './DropzoneFileRowContainer';
import Loading from '@innovyze/stylovyze/lib/components/Loading';
import S3Utils from '@innovyze/stylovyze/lib/utils/s3utils';
import { UpArrowCircle } from './icons';
import UploadFilePaper from './icons/UploadFilePaper';
import { useGlobalization } from '@innovyze/stylovyze/lib/contexts/GlobalizationProvider';
import { useState } from 'react';
/**
 * Add a description for your component here
 */
export const FileDropzone = (props) => {
    const { t } = useGlobalization();
    const { downloadApiUrl, deleteApiUrl, token } = props;
    const initialAttachedFiles = props.files || [];
    const [files, setFiles] = useState(initialAttachedFiles);
    const [uploading, setUploading] = useState(false);
    let handleDownloadClick = undefined;
    let handleDeleteClick = undefined;
    if (downloadApiUrl)
        handleDownloadClick = (af) => async () => {
            const utils = new S3Utils();
            const { path, dateCreated } = af;
            const fileProperties = {
                ...af?.props,
                ...props.params,
            };
            utils
                .downloadFromS3(downloadApiUrl ?? '', {
                path,
                dateCreated,
                ...fileProperties,
            }, token)
                .then(resp => {
                if (resp?.location) {
                    const href = document.createElement('a');
                    href.setAttribute('href', resp.location);
                    href.setAttribute('download', 'download');
                    href.click();
                    href.remove();
                }
            });
        };
    if (deleteApiUrl)
        handleDeleteClick =
            (af, index) => async () => {
                const utils = new S3Utils();
                const { path, dateCreated } = af;
                const fileProperties = {
                    ...af?.props,
                    ...props.params,
                };
                utils
                    .delete(deleteApiUrl, {
                    path,
                    dateCreated,
                    ...fileProperties,
                }, token)
                    .then(() => {
                    const newFiles = files;
                    newFiles.splice(index, 1);
                    setFiles([...newFiles]);
                    if (props.onFileDelete)
                        props.onFileDelete(af);
                });
            };
    const onDropAccepted = (acceptedFiles, evt) => {
        const acceptedUploadedFiles = [];
        if (props.signApiUrl) {
            const uploader = new S3Utils();
            setUploading(true);
            uploader
                .uploadToS3(props?.signApiUrl, acceptedFiles, props.params || {}, props.token)
                .then(signedResponses => {
                const attachedFiles = [];
                acceptedFiles.forEach(file => {
                    const signedResponse = signedResponses?.find(el => file.name == el.name);
                    acceptedUploadedFiles.push({
                        ...file,
                        dateCreated: signedResponse?.dateCreated || -1,
                    });
                    attachedFiles.push({
                        path: file.name,
                        dateCreated: signedResponse?.dateCreated || -1,
                    });
                });
                setFiles([...files, ...attachedFiles]);
                if (props.dropzoneOptions?.onDropAccepted)
                    props.dropzoneOptions.onDropAccepted(acceptedUploadedFiles, evt);
                setUploading(false);
            })
                .catch(() => setUploading(false));
        }
        else {
            const attachedFiles = [];
            acceptedFiles.forEach(file => {
                acceptedUploadedFiles.push({
                    ...file,
                    dateCreated: file.lastModified,
                });
                attachedFiles.push({
                    path: file.name,
                    dateCreated: file.lastModified,
                });
            });
            setFiles([...files, ...attachedFiles]);
            if (props.dropzoneOptions?.onDropAccepted)
                props.dropzoneOptions.onDropAccepted(acceptedFiles, evt);
        }
    };
    const getDragClassName = (isDragActive, isDragAccept, isDragReject) => {
        const classNames = [];
        if (isDragAccept)
            classNames.push('drag-accept');
        if (isDragActive)
            classNames.push('drag-active');
        if (isDragReject)
            classNames.push('drag-reject');
        return classNames.join(' ');
    };
    const getDZBody = (isDragActive, isDragAccept, isDragReject) => {
        if (files.length) {
            return (React.createElement(DropzoneInfoContainerMini, { className: getDragClassName(isDragActive, isDragAccept, isDragReject) },
                React.createElement(DropzoneInfoContainerLabelMini, null,
                    React.createElement(UploadFilePaper, { fill: isDragReject ? '#AA0000' : '#4A6067' }),
                    React.createElement("div", null, isDragReject
                        ? t(
                        // eslint-disable-next-line quotes
                        "The files you're trying to import are in an invalid format", { context: 'File dropzone' })
                        : t('Drag and drop files here', {
                            context: 'File dropzone',
                        })))));
        }
        else {
            const maxSize = (props?.dropzoneOptions?.maxSize || 0) / (1024 * 1024);
            return (React.createElement(DropzoneInfoContainerFull, { "data-testid": "dropzone", className: getDragClassName(isDragActive, isDragAccept, isDragReject) },
                React.createElement(StyledDropzoneFileRowContainer, null,
                    React.createElement(UpArrowCircle, { fill: isDragReject ? '#AA0000' : '#C9D6DC' }),
                    React.createElement("h3", null, isDragReject
                        ? t(
                        // eslint-disable-next-line quotes
                        "The files you're trying to import are in an invalid format", { context: 'File dropzone' })
                        : t('Drag and drop files here', {
                            context: 'File dropzone',
                        })),
                    React.createElement("p", null, props?.supportedFileText ||
                        t('Supported file types include: .doc, .xls, .png, .mp3, .mp4', { context: 'File dropzone' })),
                    props?.dropzoneOptions?.maxSize ? (React.createElement("p", null, t('Max size {{maxSize}} MB', {
                        maxSize,
                        context: 'File dropzone',
                    }))) : null)));
        }
    };
    return (React.createElement(Container, null,
        React.createElement(DropzoneFileRowContainer, { files: files, params: props?.params, onDownloadClick: handleDownloadClick, onDeleteClick: handleDeleteClick, token: props.token }),
        props.noUpload ? null : (React.createElement(Dropzone, { ...props, accept: props?.dropzoneOptions?.accept, maxSize: props?.dropzoneOptions?.maxSize, maxFiles: props?.dropzoneOptions?.maxFiles, validator: props?.dropzoneOptions?.validator, getFilesFromEvent: props?.dropzoneOptions?.getFilesFromEvent, multiple: true, onDrop: props?.dropzoneOptions?.onDrop, onDropAccepted: props?.onDropAcceptedExternal || onDropAccepted }, ({ getRootProps, getInputProps, isDragActive, isDragAccept, isDragReject, }) => (React.createElement(FittedLoader, null,
            React.createElement(Loading, { loading: uploading },
                React.createElement(StyledDropzoneArea, { ...getRootProps({
                        className: 'dropzone',
                    }) },
                    React.createElement("input", { ...getInputProps() }),
                    getDZBody(isDragActive, isDragAccept, isDragReject)))))))));
};
FileDropzone.defaultProps = {};
export default FileDropzone;
